export default __webpack_public_path__ + "navigation-overview-view-hierarchy-960-144202149a9f46d87451b8c1e8c9c1ce.png";